import { DEFAULT_PROPERTY_CARD } from 'src/constants/property';
import { FilterModal } from '../FilterModal/FilterModal';
import {
  FilterSelectorMenu,
  ViewType,
} from '../FilterSelectorMenu/FilterSelectorMenu';
import { PropertiesList } from '../../modules/Properties/PropertiesList';
import { getCustomSvgMarker } from './getCustomSvgMarker';
import MapWithSearch from '../MapWithSearch/MapWithSearch';
import React from 'react';

const POSITIONS = [
  { lat: -11.721797137880776, lng: -44.92035726821708 },
  { lat: -16.28932375340698, lng: -45.76551127052593 },
  { lat: -16.112705844623864, lng: -48.44788725292968 },
  { lat: -13.026136181257375, lng: -48.97468718505191 },
  { lat: -18.381958064570153, lng: -52.27771962797927 },
  { lat: -18.031047826727434, lng: -45.43400431788253 },
  { lat: -22.14353191908077, lng: -48.23409105456161 },
].map((position, idx) => {
  const distance = (idx + 1) * 33;

  const impar = idx % 2 === 0;

  return {
    ...position,
    icon: {
      url: `data:image/svg+xml;charset=UTF-8;base64, ${btoa(
        getCustomSvgMarker(distance, impar ? 'buyer' : 'producers')
      )}
      `,
    },
  };
});

export const SearchProviderPerson = () => {
  const [currentView, setCurrentView] = React.useState<ViewType>('map');
  const [filterIsOpen, setFilterIsOpen] = React.useState(false);

  const list = Array.from({ length: 9 }).map(() => {
    return { ...DEFAULT_PROPERTY_CARD };
  });

  const handleOpenFilters = () => {
    setFilterIsOpen(true);
  };

  return (
    <>
      <FilterModal
        title="Filtros"
        type="provider"
        isOpen={filterIsOpen}
        onClose={() => {
          setFilterIsOpen(false);
        }}
        onFilter={(data) => {
          setFilterIsOpen(false);
          alert(JSON.stringify(data));
        }}
      />
      <MapWithSearch
        customSubMenu={
          <FilterSelectorMenu
            onFilter={handleOpenFilters}
            onChangeMapView={setCurrentView}
            currentView={currentView}
          />
        }
        hideMap={currentView === 'list'}
        markedPositions={POSITIONS}
        hideSubMenu
      >
        {currentView === 'list' && <PropertiesList list={list} />}
      </MapWithSearch>
    </>
  );
};
